import { useState } from 'react';
import { DialogUI } from '../Interface';
import { useFormikContext } from 'formik';
import { Box, Typography } from '@mui/material';
import { sxConfig } from '../Interface/interface.style';
import { CostCenterPage } from './CostCenterPage';

const CostCenterDialog = ({ showDialog, onClose }) => {
  const { setFieldValue } = useFormikContext();
  const [selectedCostCenter, setSelectedCostCenter] = useState(null);

  const handleClose = () => {
    if (onClose) {
      // ha nincs kiválasztott cikk, null-lal hívjuk vissza
      onClose(selectedCostCenter?.code ?? null, setFieldValue);
    }
    // lokális állapot reset a következő nyitáshoz
    setSelectedCostCenter(null);
  };

  return (
    <DialogUI
      open={showDialog}
      headerContent={'Költséghely'}
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      actionsContent={
        selectedCostCenter?.code ? (
          <Box sx={sxConfig.dialogActionContent}>
            <Typography variant="body2" noWrap sx={sxConfig.dialogActionContentTypography1}>
              Választott költséghely:
              <Box component="span" sx={sxConfig.dialogActionContentTypography2}>
                {selectedCostCenter?.name}
              </Box>
            </Typography>
          </Box>
        ) : null
      }
      maxWidth="xl"
    >
      <CostCenterPage fromDialog={true} dialogSetSelectedCostCenter={setSelectedCostCenter} />
    </DialogUI>
  );
};

export default CostCenterDialog;
